import { api, type ReactQueryOptions, type RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'
import { useSession } from '@shared/hooks/useSession'

type optionsType = ReactQueryOptions['StoreManager']['getUserStoreItems']
type inputType = RouterInputs['StoreManager']['getUserStoreItems']

/**
 Возвращает только свои стор айтемы
 **/

export const useGetUserStoreItems = (input: inputType, options?: optionsType) => {
    const { status } = useSession()

    return api.StoreManager.getUserStoreItems.useQuery(input, {
        ...options,
        queryKey: ['StoreManager.getUserStoreItems', input],
        refetchOnWindowFocus: false,
        staleTime: 2 * 60 * 1000 * staleTimeIndex * 60, // 2 hours
        enabled: status === 'authenticated' && options?.enabled,
    })
}
